import axios from 'axios';
import qs from 'qs';
// import { handleLogout } from '../auth/logout';


const baseURL = `${window.location.origin}/`;

const baseapi = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
  paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
});

baseapi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

baseapi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // handleLogout();
      console.log("401 Unauthorized");
    }
    return Promise.reject(error);
  }
);

export default baseapi;

export interface StreamChunk {
  type: 'step' | 'image' | 'answer';
  text?: string;
  b64?: string;
  caption?: string;
}

export const sendChatMessageStream = async (
  message: string,
  sessionId: string,
  onChunk: (chunk: StreamChunk) => void
): Promise<void> => {
  const token = localStorage.getItem('access_token');
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    'X-API-Key': '__BOT_API_KEY__',
  };
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const response = await fetch(`${window.location.origin}/ai-bot/chat`, {
    method: 'POST',
    headers,
    body: JSON.stringify({ message, session_id: sessionId }),
  });

  if (!response.ok) {
    throw new Error(`Chat API error: ${response.status} ${response.statusText}`);
  }

  const reader = response.body?.getReader();
  if (!reader) {
    throw new Error('Readable stream is not supported in this browser.');
  }

  const decoder = new TextDecoder('utf-8');
  let buffer = '';

  while (true) {
    const { done, value } = await reader.read();
    if (done) break;

    buffer += decoder.decode(value, { stream: true });
    let newlineIndex: number;

    while ((newlineIndex = buffer.indexOf('\n')) >= 0) {
      const line = buffer.slice(0, newlineIndex).trim();
      buffer = buffer.slice(newlineIndex + 1);

      if (line) {
        try {
          const parsed = JSON.parse(line) as StreamChunk;
          onChunk(parsed);
        } catch (err) {
          console.error('Error parsing NDJSON chunk:', err, 'Line content:', line);
        }
      }
    }
  }
};

